<template>
  <ReflectionCard class="mt-10">
    <template #header>
      <span>Now what?</span>
    </template>
    <template #content>
      <div class="text-dark-grey text-xxs">
        <p>
          Did you experience any knowledge gaps? Are there certain areas that you think you would
          benefit from developing further? What would you do differently next time, if anything?
        </p>
        <br />
        <p class="mb-3">eg. 'What can I learn from or do differently next time'</p>
      </div>
      <textarea
        ref="nowWhatRef"
        rows="4"
        v-model="now_what_field"
        @input="onInput"
        class="w-full border border-gray-200 rounded text-sm resize-none overflow-hidden"
        style="min-height: 6rem"
      ></textarea>
    </template>
  </ReflectionCard>
</template>

<script>
import ReflectionCard from './Components/ReflectionCard.vue';

export default {
  name: 'NowWhatCard',
  components: { ReflectionCard },
  props: {
    initialValue: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.nowWhatRef;
      if (!el) return;

      const observer = new ResizeObserver(() => {
        if (el.offsetParent !== null) {
          this.autoResize();
          observer.disconnect();
        }
      });
      observer.observe(el);
    });
  },
  data() {
    return {
      now_what_field: this.initialValue ?? this.$page.props.session.reflection?.now_what,
    };
  },
  watch: {
    now_what_field: {
      immediate: true,
      handler() {
        if (this.$refs.nowWhatRef?.offsetParent !== null) {
          this.$nextTick(this.autoResize);
        }
      },
    },
  },
  methods: {
    emitFieldChange() {
      this.$emit('fieldChanged', {
        field: 'now_what',
        value: this.now_what_field,
      });
    },
    onInput() {
      this.autoResize();
      this.emitFieldChange();
    },
    autoResize() {
      const el = this.$refs.nowWhatRef;
      if (!el) return;
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    },
  },
};
</script>

<style scoped></style>
